var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrToolBar',{attrs:{"addlFilter":_vm.addlFilter,"configFilter":_vm.configFilter},on:{"search":_vm.buscar}})}
var staticRenderFns = []

export { render, staticRenderFns }